import { render, staticRenderFns } from "./ClientSecretModal.vue?vue&type=template&id=35af649c"
import script from "./ClientSecretModal.vue?vue&type=script&lang=js"
export * from "./ClientSecretModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports